import { useEffect } from 'react';

/**
 * useSprintKeyboard Hook
 * 
 * Handles keyboard shortcuts for the SprintDetail component:
 * - Ctrl+Z (Cmd+Z on Mac): Undo
 * - Ctrl+Y or Ctrl+Shift+Z (Cmd+Y or Cmd+Shift+Z on Mac): Redo
 * 
 * Shortcuts are disabled when user is typing in an input/textarea.
 * 
 * @param {Object} options
 * @param {Function} options.undo - Undo function from useSprintSync
 * @param {Function} options.redo - Redo function from useSprintSync
 */
const useSprintKeyboard = ({ undo, redo }) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Don't trigger if user is typing in an input/textarea
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.isContentEditable) {
        return;
      }
      
      const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
      const ctrlOrCmd = isMac ? e.metaKey : e.ctrlKey;
      
      if (ctrlOrCmd && e.key === 'z' && !e.shiftKey) {
        e.preventDefault();
        undo();
      } else if (ctrlOrCmd && (e.key === 'y' || (e.key === 'z' && e.shiftKey))) {
        e.preventDefault();
        redo();
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [undo, redo]);
};

export default useSprintKeyboard;

